import { render, staticRenderFns } from "./technicalarticles.vue?vue&type=template&id=082c4b09&scoped=true"
import script from "./technicalarticles.vue?vue&type=script&lang=js"
export * from "./technicalarticles.vue?vue&type=script&lang=js"
import style0 from "./technicalarticles.vue?vue&type=style&index=0&id=082c4b09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082c4b09",
  null
  
)

export default component.exports